import lodashGet from 'lodash/get';
import lodashOrderBy from 'lodash/orderBy';
import { util } from '@/api/util';
import { getContactLabel, getFlatStrOrArrInfo } from './common';
export const transOrgIdByPersonalOrg = (id) => {
    if (id.startsWith('personal_org_')) {
        return id;
    }
    return 'personal_org_' + id;
};
export const transPersonalItem2Contact = (item, _lastUpdateTime) => {
    var _a;
    const obj = {};
    obj.accountVisible = 1;
    obj.accountStatus = 0;
    obj.contactPYName = util.toPinyin(item.qiyeAccountName);
    const pinyinName = item.pinyinName || item.qiyeAccountName.split('').map((s) => util.toPinyin(s));
    obj.contactPYLabelName = pinyinName.reduce((pre, cur) => {
        pre += cur.charAt(0).toLocaleLowerCase();
        return pre;
    }, '');
    obj.contactName = item.qiyeAccountName;
    if ((_a = item.personContactGroupList) === null || _a === void 0 ? void 0 : _a.length) {
        obj.personalOrg = item.personContactGroupList.map((group) => transOrgIdByPersonalOrg(group.groupId));
    }
    const email = getFlatStrOrArrInfo(item.email);
    const tel = getFlatStrOrArrInfo(item.tel);
    const mobileList = getFlatStrOrArrInfo(item.mobileList);
    const faxList = getFlatStrOrArrInfo(item.faxList);
    let accountName = '';
    if (email) {
        accountName = (email[0] + '').toLocaleLowerCase();
    }
    else if (tel) {
        accountName = tel[0] + '';
    }
    else if (mobileList) {
        accountName = mobileList[0] + '';
    }
    else if (faxList) {
        accountName = faxList[0] + '';
    }
    else {
        accountName = item.qiyeAccountName + '';
    }
    obj.accountName = accountName;
    obj.accountOriginId = item.qiyeAccountId;
    obj.accountId = item.qiyeAccountId + '';
    obj.remark = item.remark;
    obj.priority = item.priority;
    obj.enableIM = item.enableIM;
    obj.adrList = item.adrList;
    obj.pref = item.pref;
    obj.birthday = item.birthday;
    obj.role = item.role;
    obj.title = item.title;
    obj.org = item.org;
    obj.orgname = item.orgname;
    if (item.iconVO) {
        obj.avatar = item.iconVO.mediumUrl;
        obj.avatarPendant = item.iconVO.pendantUrl;
    }
    obj.visibleCode = item.showCode === undefined ? 0 : item.showCode;
    obj.enterpriseId = -1;
    obj.id = obj.accountOriginId;
    obj.marked = item.marked;
    obj._lastUpdateTime = _lastUpdateTime;
    obj.contactLabel = getContactLabel(obj.contactPYName);
    obj.type = 'personal';
    obj.updateTime = new Date();
    return obj;
};
export const transPersonalListToContact = (list, _lastUpdateTime = Date.now()) => {
    const contactList = list.map(item => transPersonalItem2Contact(item, _lastUpdateTime));
    return contactList;
};
export const transPersonalItem2ContactInfo = (item, _lastUpdateTime) => {
    const itemList = [];
    const rs = {
        contactItemVal: '',
        contactItemRefer: '',
        contactItemType: '',
        isDefault: 0,
        emailType: -1,
        contactId: item.qiyeAccountId,
    };
    itemList.push(...getFlatStrOrArrInfo(item.email.map((subEmail) => subEmail.toLocaleLowerCase()), 'EMAIL', rs));
    itemList.push(...getFlatStrOrArrInfo(item.faxList, 'FAX', rs));
    itemList.push(...getFlatStrOrArrInfo(item.tel, 'TEL', rs));
    itemList.push(...getFlatStrOrArrInfo(item.mobileList, 'MOBILE', rs));
    return itemList.map(_item => (Object.assign(Object.assign({}, _item), { contactItemVal: _item.contactItemVal, type: 'personal', _lastUpdateTime, id: util.getUnique(_item.contactId, _item.contactItemType, _item.contactItemVal) })));
};
export const transPersonalListToContactInfo = (list, _lastUpdateTime = Date.now()) => {
    return list.map(item => transPersonalItem2ContactInfo(item, _lastUpdateTime)).flat();
};
export const transPersonalItem2OrgContact = (item, _lastUpdateTime) => {
    const contactId = item.qiyeAccountId;
    return lodashGet(item, 'personContactGroupList', []).map(({ groupId }) => {
        const orgId = transOrgIdByPersonalOrg(groupId);
        return {
            id: util.getUnique(orgId, contactId),
            orgId,
            contactId,
            updateTime: new Date(_lastUpdateTime),
            type: 'personal',
            enterpriseId: -1,
            _lastUpdateTime,
        };
    });
};
export const transPersonalListToOrgContact = (list, _lastUpdateTime = Date.now()) => {
    return list.map(item => transPersonalItem2OrgContact(item, _lastUpdateTime)).flat();
};
export const transPersonalContact2MutipleData = (list, _lastUpdateTime) => {
    const contactList = [];
    const contactItemList = [];
    const orgContactList = [];
    const personalIds = [];
    const markedList = [];
    list.forEach(item => {
        const contact = transPersonalItem2Contact(item, _lastUpdateTime);
        const contactItem = transPersonalItem2ContactInfo(item, _lastUpdateTime);
        const orgContact = transPersonalItem2OrgContact(item, _lastUpdateTime);
        if (typeof item.marked === 'number' && item.marked > 0) {
            markedList.push(transPersonal2Mark(item, _lastUpdateTime));
        }
        contactList.push(contact);
        contactItemList.push(...contactItem);
        orgContactList.push(...orgContact);
        personalIds.push(contact.id);
    });
    return {
        contact: contactList,
        contactItem: contactItemList,
        orgContact: orgContactList,
        personalIds,
        markedList,
    };
};
export const transPersonal2Mark = (item, _lastUpdateTime, type = 1) => {
    if (type === 1) {
        return {
            value: item.qiyeAccountId,
            name: item.qiyeAccountName,
            emails: item.email,
            marked: item.marked,
            originId: item.qiyeAccountId,
            _lastUpdateTime,
            type: 1,
        };
    }
    return {
        type: 2,
        value: `personal_org_${item.groupId}`,
        name: item.groupName,
        emails: [],
        marked: item.marked,
        originId: item.groupId,
        _lastUpdateTime,
    };
};
export const transferPersonalList2PersonalMark = (list, type = 1, _lastUpdateTime = Date.now()) => {
    const markedList = [];
    list.forEach(item => {
        if (typeof item.marked !== 'number' || item.marked <= 0) {
            return;
        }
        markedList.push(transPersonal2Mark(item, _lastUpdateTime, type));
    });
    return markedList;
};
export const transPersonalOrgContact = (list, orgIdList) => {
    const res = [];
    const updateTime = Date.now();
    list.forEach(contactId => {
        orgIdList.forEach(groupId => {
            const orgId = transOrgIdByPersonalOrg(groupId);
            res.push({
                id: util.getUnique(orgId, contactId),
                orgId,
                contactId,
                updateTime,
                enterpriseId: -1,
            });
        });
    });
    return res;
};
export const transPersonalGroup2EntityOrgList = (list, _lastUpdateTime) => {
    const groupList = [];
    const markedList = [];
    list.forEach(item => {
        const { groupId: id, groupName: name, marked } = item;
        groupList.push({
            id: transOrgIdByPersonalOrg(id),
            orgName: name,
            orgPYName: util.toPinyin(name),
            originId: id,
            type: 2001,
            visibleCode: 0,
            parent: 'personal_org',
            orgRank: 1,
            updateTime: _lastUpdateTime,
            marked,
            _lastUpdateTime,
        });
        if (typeof marked === 'number' && marked > 0) {
            markedList.push(transPersonal2Mark(item, _lastUpdateTime, 2));
        }
    });
    return {
        groupList,
        markedList,
    };
};
export const transformPersonalParam2PersonalMarkEntityList = (model) => {
    const _lastUpdateTime = Date.now();
    if (Array.isArray(model.emailList) && model.emailList.length) {
        return [
            {
                id: util.getUnique(model.accountId),
                value: model.accountId,
                marked: model.marked,
                type: 1,
                emails: model.emailList,
                name: model.name,
                _lastUpdateTime,
            },
        ];
    }
    return [
        {
            id: util.getUnique(model.accountId),
            value: model.accountId,
            marked: model.marked,
            type: 1,
            emails: [],
            name: model.name,
            _lastUpdateTime,
        },
    ];
};
export const transfromPersonalMarkRawData = (rawDataList) => {
    return lodashOrderBy(rawDataList, ['marked']);
};
